module.exports = __webpack_public_path__ + "media/tips/02_linges_de_maison-142b8317.jpg";